export default __webpack_public_path__ + "static/media/down.4feb75a3.gif";